export default "__VITE_ASSET__93c5fe3b__"